import {SummaryItem} from "@echo-nx/marlenka/common";

export const priceDescComparator = (a:SummaryItem, b:SummaryItem) => a.totalPrice > b.totalPrice ? -1 : 1
